import { CircularProgress, TablePaginationProps } from '@mui/material'
import {
  GridPagination,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid-premium'
import isNil from 'lodash/isNil'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface CustomPaginationProps {
  totalCountLoading: boolean
}

export const CustomPagination: React.FC<CustomPaginationProps> = ({ totalCountLoading }) => {
  const { t } = useTranslation('common')
  const apiRef = useGridApiContext()
  const page = useGridSelector(apiRef, gridPageSelector)
  const pageCount = useGridSelector(apiRef, gridPageCountSelector)

  // Get pagination state from the grid
  const paginationModel = apiRef.current.state.pagination?.paginationModel
  const rowCount = apiRef.current.state.pagination?.rowCount ?? 0

  const labelDisplayedRows = useMemo(() => {
    if (totalCountLoading) {
      const LoadingLabel = ({ from, to }: { from: number; to: number }) => (
        <>
          {t('table.table-footer.total-count', { from, to })}{' '}
          <CircularProgress size={12} sx={{ verticalAlign: 'middle', m: 2 }} />
        </>
      )
      return LoadingLabel
    }
    return undefined
  }, [totalCountLoading, t])

  if (isNil(paginationModel)) {
    return <GridPagination />
  }

  return (
    <GridPagination
      slotProps={{
        actions: {
          ...(totalCountLoading && {
            previousButton: {
              disabled: page === 0,
            },
            nextButton: {
              disabled: page >= pageCount - 1 || rowCount === 0,
            },
          }),
        },
      }}
      labelDisplayedRows={labelDisplayedRows as TablePaginationProps['labelDisplayedRows']}
    />
  )
}
